import ModalWrapper from 'Components/Modals/ModalWrapper'
import React, { useState } from 'react'
import { Input, Label, Row, Col, Button } from 'reactstrap';
import Select from "react-select";


function UpdateModal({title, options, onClose, onSave, user_note, status}) {
    const [selectedOption, setSelectedOption] = useState(options.find(option => option.value === status));
    const [note, setNote] = useState(user_note);

    const handleSave = () => {
        onSave(note, selectedOption.value);
    };
  return (
    <ModalWrapper
      show={true}
      title={title}
      onCloseClick={onClose}
      body={
        <>
          <div>
            <Row>
                <Col className="mb-3">
                    <Label htmlFor='note'>Note: </Label>
                    <Input
                        id="note"
                        name="note"
                        type="textarea"
                        rows="3"
                        placeholder="Enter your note here"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                      />
                </Col>
            </Row>
            <Row>
                <Col className="mb-3">
                    <Label htmlFor="location">Status: </Label>
                    <Select
                    id="location"
                    name="location"
                    placeholder="Select Location"
                    options={options}
                    value={selectedOption}
                    onChange={(value) => setSelectedOption(value)}
                    />
                  </Col>
            </Row>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <Button color="secondary" className="me-2" onClick={onClose}>Cancel</Button>
            <Button color="primary" onClick={handleSave}>Save Changes</Button>
          </div>
        </>
      }
    />
  )
}

export default UpdateModal
